<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      class="b"
      d="M17.71 21.73H6.46A2.46 2.46 0 014 19.27V4.46A2.46 2.46 0 016.46 2h7.38a.74.74 0 01.52.21l5.6 5.6a.74.74 0 01.22.52v10.94a2.46 2.46 0 01-2.47 2.46zM6.46 3.47a.99.99 0 00-.99.99v14.81a.99.99 0 001 .99H17.7a.99.99 0 00.99-.99V8.63l-5.17-5.16z"
    />
    <path
      class="b"
      d="M18.99 8.83h-3.74a2.38 2.38 0 01-2.38-2.38V2.71a.71.71 0 111.42 0v3.74a.96.96 0 00.96.96h3.74a.71.71 0 110 1.42zM6.37 12.86a.33.33 0 01.37-.3h1.3a1.32 1.32 0 011.48 1.45v.03a1.36 1.36 0 01-1.55 1.46h-.62v1.36c0 .2-.24.3-.49.3s-.49-.1-.49-.3zm.98.56v1.33h.62c.36 0 .57-.2.57-.63v-.07c0-.42-.21-.63-.57-.63zM11.64 12.57a1.37 1.37 0 011.55 1.48v1.63a1.37 1.37 0 01-1.55 1.48h-1.11c-.26 0-.43-.13-.43-.3v-4c0-.15.17-.3.43-.3zm-.56.85v2.89h.56c.35 0 .57-.2.57-.63v-1.63c0-.42-.22-.63-.57-.63zM13.96 12.87c0-.2.22-.3.43-.3h2.18c.2 0 .3.22.3.42 0 .24-.1.44-.3.44h-1.63v1.06h.95c.2 0 .3.18.3.38 0 .17-.09.37-.3.37h-.95v1.63c0 .2-.24.3-.49.3s-.49-.1-.49-.3z"
    />
  </g>
</template>
 <style scoped>
.b{fill:currentColor}
</style>